/** Selected variant thumb wrapper: gradient (default) vs solid outline using `--ov25-highlight-color`. */
export const OV25_VARIANT_THUMB_RING_MODE_VAR = '--ov25-variant-thumb-ring-mode' as const;

export const OV25_VARIANT_RING_MODE_SOLID = 'solid' as const;
